import { render, staticRenderFns } from "./TaskSearch.vue?vue&type=template&id=0b9593ba&"
import script from "./TaskSearch.vue?vue&type=script&lang=js&"
export * from "./TaskSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports